import React, { useEffect, useState } from "react";
import "./CustomField.css";
import Button from "@mui/material/Button";
import { Drawer, ModalClose } from "@mui/joy";
import { axiosInstance } from "../../utility/apiInstance";
import toast from "react-hot-toast";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Loading from "../../components/AWBDashboard/Loading";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchInput from "../../common/SearchInput";


const BASE_URL = "/api/v1/custom-form";
const dropdown_URL = "/api/v1/custom-form/field-types";



function CustomField() {

  // START Select
  const [selectedIndex, setSelectedIndex] = useState<string | null>(null);
  const [allField, setAllField] = useState([]);
  const [singleField, setSingleField] = useState<any>({
    name: "",
    description: "",
    fieldType: "",
  });
  const [dropdownField, setDropdownField] = useState<any>([]);
  const [errors, setErrors] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(["High-1"]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");



  // debounce search effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);


  // Fix the debounced effect — pass the string directly
  useEffect(() => {
    getCustomForms(debouncedSearch);  
  }, [debouncedSearch]);

  // validate drawer entries
  const validateFields = (data: any) => {
    const newErrors: any = {};

    if (!data.fieldName?.trim()) {
      newErrors.fieldName = "Field name is required";
    }

    if (!data.fieldType?.trim()) {
      newErrors.fieldType = "Please select a field type";
    }
    if (!data.description?.trim()) {
      newErrors.description = "Description is required";
    }



    const hasSelected = options?.some((row) => row === "")


    if (data.fieldType === "68df9d4824a7350632b4aedf" && options.length === 0) {
      newErrors.options = hasSelected ? "Please fill the options" : "Please add at least one option";

    }
    if (data.fieldType === "68df9d4824a7350632b4aedf" && hasSelected) {
      newErrors.options = "Please fill the options";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ true = valid
  };

  // START Drawer
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleClickOpen = () => {
    setConfirmOpen(true);
  };

  const handleClose = () => {
    setConfirmOpen(false);
  };
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  // END Drawer

  // START Dropdown Options State


  const addOption = () => {
    setOptions([...options, ""]);
  };

  const handleChange = (index: number, value: string) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const removeOption = () => {
    if (options.length > 1) {
      setOptions(options.slice(0, -1));
    }
  };
  // END Dropdown Options State

  const createCustomForm = async (payload: any) => {
    try {
      const response = await axiosInstance.post(BASE_URL, { ...payload, dropdownOptions: options });
      setOpen(false);
      getCustomForms()
      toast.success("Field created successfully!");
      return response.data;
    } catch (error: any) {
      toast.error("Oops! Something went wrong. Please try again.");
      throw error;
    }
  };

  const deleteCustomForm = async (id: any) => {
    try {
      const response = await axiosInstance.patch(`${BASE_URL}/${id}`, { active: false });
      toast.success("Field deleted successfully!");
      getCustomForms();
      return response.data;
    } catch (error: any) {
      toast.error("Oops! Something went wrong. Please try again.");
      throw error;
    }
  };


  const getCustomForms = async (search = "") => {
    try {
      setIsLoading(true);
      const params = search.trim() ? { search } : {};                    // 👈 build params

      const fieldTypeRes = await axiosInstance.get(dropdown_URL);        // 👈 no search needed for field types
      setDropdownField(fieldTypeRes.data.data);

      const response = await axiosInstance.get(BASE_URL, { params });    // 👈 pass search param
      setAllField(response.data.data.filter((item: any) => item.active === true));
    } catch (error: any) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const updateCustomForm = async (id: any, updates: any) => {
    try {
      let payload = {
        ...updates,
        // fieldType:dropdownField.find((item: any) => item.name === updates.fieldType)?._id,
        dropdownOptions: options
      }
      const response = await axiosInstance.patch(`${BASE_URL}/${id}`, { ...payload, dropdownOptions: options });
      // setSingleField(response.data.data);
      getCustomForms();
      setOpen(false);
      // setSingleField({})
      toast.success("Field updated successfully!");
    } catch (error: any) {
      toast.error("Oops! Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    getCustomForms(); // 👈 called only on first render
  }, []);

  const handleUniqueChanged = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = event.target.checked;

    setSingleField((prev: any) => ({
      ...prev,
      isUnique: checked,
      required: prev.required ? prev.required : checked,
    }));
  };

  const handleRequiredChanged = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = event.target.checked;

    setSingleField((prev: any) => ({
      ...prev,
      // if unique is true -> required must always stay true
      required: prev.isUnique ? true : checked,
    }));
  };

  return (
    <>

      <Dialog className="customFieldModal"
        open={confirmOpen}
        // slots={{
        //   transition: Transitionprops => <Slide {...Transitionprops} direction="up" />,
        // }}
        keepMounted={false}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent className="customFieldContent">
          <DialogContentText id="alert-dialog-slide-description">
            This action will delete the field permanently.
          </DialogContentText>
        </DialogContent>
        <DialogActions className="customFieldBtn">
          <Button className="btn btnYellow" onClick={handleClose}><ArrowBackIcon />Back</Button>
          <Button className="btn btnBlack" onClick={() => { deleteCustomForm(singleField._id); handleClose() }}><DeleteIcon />Delete</Button>
        </DialogActions>
      </Dialog>

      <Drawer open={open} className="drawerPropertiesPanel" anchor="right"

        onClose={() => setOpen(false)}
        slotProps={{
          content: {
            sx: {
              width: {
                xs: '95%',
                sm: '90%',
                md: 500,
                lg: 700,
              },
            },
          },
        }}
      >
        <ModalClose />
        <div className="propertiesPanel">
          <h3>Field Properties</h3>
          <p>Configure the selected field properties and validation rules.</p>
          <form>
            <div className="form-group">
              <label className="form-label">Field Name</label>
              <input type="text" className="form-control" value={singleField.fieldName || ""} placeholder="Enter field name" onChange={(event) => setSingleField((prev: any) => ({ ...prev, fieldName: event.target.value }))} />
              {errors.fieldName && <span className="error">{errors.fieldName}</span>}
            </div>

            <div className="form-group">
              <label className="form-label">Field Type</label>
              <select
                className="form-select"
                value={singleField.fieldType || ""}
                onChange={(event) => {
                  {
                    setSingleField((prev: any) => ({
                      ...prev,
                      fieldType: event.target.value,
                    }))
                    if (event.target.value == "68df9d4824a7350632b4aedf") {
                      return;
                    }
                    else {
                      setOptions([]);
                    }
                  }
                }}
              >
                <option value="" disabled hidden>
                  Select field type
                </option>
                {dropdownField.map((field: any) => (
                  <option key={field._id} value={field._id}>
                    {field.name}
                  </option>
                ))}
              </select>
              {errors.fieldType && <span className="error">{errors.fieldType}</span>}
            </div>

            <div className="form-group">
              <label className="form-label">Description</label>
              <input type="text" className="form-control" value={singleField.description || ""} placeholder="Help text for users" onChange={(event) => setSingleField((prev: any) => ({ ...prev, description: event.target.value }))} />
              <small className="form-group-text">Max 200 characters</small>
              {errors.description && <span className="error"><br />{errors.description}</span>}
            </div>

            <div className="form-group">
              <label className="form-label">Default Value (Optional)</label>
              <input type="text" className="form-control" value={singleField.defaultValue || ""} placeholder="Enter default value" onChange={(event) => setSingleField((prev: any) => ({ ...prev, defaultValue: event.target.value }))} />

            </div>

            <div className="form-group">
              <div className="checkbox-group">
                <input
                  type="checkbox"
                  id="mandatory"
                  className="form-checkbox"
                  checked={singleField.required}
                  onChange={handleRequiredChanged}
                />

                <label htmlFor="mandatory" className="form-label">
                  Required Field
                </label>
              </div>

              <small className="form-group-text">
                Users must fill this field when entering tracking numbers
              </small>
            </div>
            <div className="form-group">
              <div className="checkbox-group">
                <input
                  type="checkbox"
                  id="uniqueValues"
                  className="form-checkbox"
                  checked={singleField.isUnique || false}
                  onChange={handleUniqueChanged}
                />
                <label htmlFor="uniqueValues" className="form-label">Unique Values</label>
              </div>
              <small className="form-group-text">Each entry for this field must have a unique value</small>
            </div>

            {singleField.fieldType === "68df9d4824a7350632b4aedf" && <div className="form-group formDropdown">
              <label className="form-label">Dropdown Options</label>
              <div>
                {options && options.map((option, index) => (
                  <input
                    key={index}
                    type="text"

                    className="formDropdownInput"
                    value={option}
                    onChange={(e) => handleChange(index, e.target.value)}
                    placeholder={`Option ${index + 1}`}
                    style={{ display: "block", marginBottom: "5px" }}
                  />
                ))}
                {errors.options && <span className="error">{errors.options}</span>}
              </div>
              <div className="formFlex">
                <button type="button" className="btn btnPlus" onClick={addOption}>+ Add Option</button>
                <button type="button" className="btn btnMinus" onClick={removeOption}>Remove</button>
              </div>
            </div>}

            <div className="btnGroup">
              <button
                type="button"
                className="btn btnYellow"
                onClick={() => {
                  if (validateFields(singleField)) {
                    const normalizeName = (name: string) =>
                      name.trim().toLowerCase(); // only trims, keeps spaces

                    const isDuplicate = allField.some((field: typeof singleField) => {
                      if (!field.fieldName || !singleField.fieldName) return false;
                      return (
                        normalizeName(field.fieldName) === normalizeName(singleField.fieldName) &&
                        field._id !== singleField._id
                      );
                    });

                    if (isDuplicate) {
                      alert("Field name already exists!");
                      return;
                    }

                    if (singleField._id) {
                      updateCustomForm(singleField._id, singleField);
                    } else {
                      createCustomForm(singleField);
                    }

                    // getCustomForms();
                    // setOpen(false);
                  }
                }}
              >
                Save Field
              </button>
              <button type="button" className="btn btnBlack" onClick={() => { setOpen(false); setSingleField({}) }}>Cancel</button>
            </div>
          </form>
        </div>
      </Drawer>


      <section className="customFieldMain">
        <div className="headerCustomField">
          <h1>Manage Custom Fields</h1>
          <p>Configure custom fields for tracking numbers. Define field types and
            validation rules</p>
        </div>

        <div className="fieldListSection">
          <div className="sectionHeader">
            <h2>Custom Fields</h2>
            <SearchInput
              placeholder="Search Grouping"
              onChange={setSearchQuery}
              width={400}
            />
            <button className="btn btnYellow" onClick={() => { if (allField.length >= 19) { toast.error("You can't add more than 20 fields"); } else { setOpen(true); setSingleField({}); setOptions([]); setErrors({}); } }}>+ Add New Field</button>
          </div>

          {/* Field 1 */}
          {isLoading ? (<div className="flex justify-center items-center h-[200px] relative">
            <Loading />
          </div>) : allField.map((field: any, index) => <div
            key={field._id}
            className={`fieldListing ${selectedIndex === field._id ? "selected" : ""}`}
            onClick={() => setSelectedIndex(field._id)}
          >
            <div className="fieldHeader">
              <span className="fieldName">
                {field.fieldName}{" "}
                <span className="mandatory-indicator">{field.required ? "*" : ""}</span>
              </span>
              <div className="fieldHeaderRight">
                {field.isUnique && (
                  <span className="uniqueBadge">Unique</span>
                )}
                <span className="fieldType">
                  {dropdownField.find((item: any) => item._id === field.fieldType)?.name || ""}
                </span>
              </div>
            </div>
            <div className="fieldsDescription">
              {field.description}
            </div>
            <div className="fieldActions">
              <button
                className="btn btnYellow"
                onClick={(e) => {
                  // e.stopPropagation(); // ✅ prevents selection on Edit click
                  setOpen(true);
                  setSingleField(field);
                  setOptions(field.dropdownOptions);
                  setErrors({});
                }}
              ><EditIcon />
                Edit
              </button>

              <button
                className="btn btnBlack"
                onClick={(e) => {
                  // e.stopPropagation(); // ✅ prevents selection on Delete click
                  handleClickOpen();
                  setSingleField(field);
                }}
              ><DeleteIcon />
                Delete
              </button>
            </div>
          </div>
          )}
        </div>
      </section>
    </>

  );
}

export default CustomField;
